'use client';

import { ISalePageDetailResponse } from '@/api/types';
import { ButtonLink, getRouterPath } from '@/components';
import { useIsLoggedIn } from '@/entities';
import { useLoginInducingModal } from '@/hooks/useLoginInducingModal';
import { trackEvent } from '@vuddy/utils';

interface CustomOrderFormCTA {
  salePage: Partial<ISalePageDetailResponse>;
}

export const CustomOrderFormCTA = ({ salePage }: CustomOrderFormCTA) => {
  const loginConfirm = useLoginInducingModal();
  const { isLoggedIn } = useIsLoggedIn();

  const handleClick = () => {
    trackEvent('shop', 'click_sale_buy', {
      channel_id: salePage?.channelId,
      sale_type: salePage?.type,
    });

    if (!isLoggedIn) {
      loginConfirm();
    }
  };

  return (
    <ButtonLink
      onClick={handleClick}
      href={!isLoggedIn ? '' : getRouterPath().customOrderForm(salePage?.id!)}
      size="large"
      fullWidth>
      주문 제작 요청
    </ButtonLink>
  );
};
